import React, { Component } from 'react'
import S from 'shorti'
import { Button, Alert } from 'react-bootstrap'
import controller from '../../controller'
import config from '../../../config/public'
import _ from 'lodash'
import './checkout.scss'
import './domains.scss'
import Card from 'react-credit-card'
class Domains extends Component {
  constructor() {
    super()
    this.state = {
      data: {}
    }
  }
  componentDidMount() {
    const data = this.state.data
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    controller.getCustomer({ access_token }, (err, res) => {
      data.payments = res.data
      this.setState({
        data
      })
    })
  }
  flipCard(side) {
    let item
    if (side === 1)
      item = 'name'
    else
      item = 'cvc'
    const data = this.state.data
    data.focused = item
    this.setState({
      data
    })
  }
  checkForValid() {
    setTimeout(() => {
      const data = this.state.data
      if (data.number && data.first_name && data.last_name && data.expiry && data.cvc)
        delete data.submit_disabled
      else
        data.submit_disabled = true
      this.setState({
        data
      })
    }, 100)
  }
  handleTextChange(key, e) {
    this.checkForValid()
    const data = this.state.data
    data[key] = e.target.value
    this.setState({
      data
    })
  }
  formHasErrors() {
    const data = this.state.data
    // Find errors
    if (data.submit_disabled) {
      data.errors = []
      if (!data.number)
        data.errors.push('number')
      if (!data.first_name)
        data.errors.push('first_name')
      if (!data.last_name)
        data.errors.push('last_name')
      if (!data.expiry)
        data.errors.push('expiry')
      if (!data.cvc)
        data.errors.push('cvc')
      this.setState({
        data
      })
      return true
    }
    return false
  }
  handleEditCardClick() {
    const data = this.state.data
    delete data.errors
    if (this.formHasErrors())
      return
    data.submitting = true
    this.setState({
      data
    })
    this.updateCurrentCard()
  }
  updateCurrentCard() {
    const data = this.state.data
    delete data.show_payment_fail
    if (!data.expiry) {
      data.show_payment_fail = true
      delete data.submitting
      delete data.submit_disabled
      this.setState({
        data
      })
      return
    }
    window.Stripe.setPublishableKey(config.stripe_pk)
    window.Stripe.card.createToken({
      name: `${data.first_name} ${data.last_name}`,
      number: data.number,
      cvc: data.cvc,
      exp_month: data.expiry.substring(0, 2),
      exp_year: '20' + data.expiry.slice(-2)
    }, (status, response) => {
      if (status === 200) {
        let access_token
        if (this.props.location)
          access_token = this.props.location.query.access_token
        const params = {
          token: response.id,
          access_token
        }
        controller.submitPayment(params, (err, res) => {
          data.stripe = res.data
          this.setState({
            data
          })
          delete data.submitting
          delete data.submit_disabled
          delete data.show_card_form
          data.show_card_updated_success = true
          this.setState({
            data
          })
        })
      } else {
        data.show_payment_fail = true
        delete data.submitting
        delete data.submit_disabled
        this.setState({
          data
        })
        return
      }
    })
  }
  showCardForm() {
    const data = this.state.data
    data.show_card_form = true
    delete data.show_card_updated_success
    delete data.show_payment_success
    data.submit_disabled = true
    this.setState({
      data
    })
  }
  hideCardForm() {
    const data = this.state.data
    delete data.show_card_form
    delete data.submit_disabled
    this.setState({
      data
    })
  }
  getCardArea() {
    const data = this.state.data
    const payments = data.payments
    let full_name = ''
    if (data.first_name)
      full_name = data.first_name + ' ' + (data.last_name ? data.last_name : '')
    let number
    let first_name
    let last_name
    let expiry
    let cvc
    if (data.number)
      number = data.number
    if (data.first_name)
      first_name = data.first_name
    if (data.last_name)
      last_name = data.last_name
    if (data.expiry)
      expiry = data.expiry
    if (data.cvc)
      cvc = data.cvc
    const last_payment = _.last(payments)
    const error_message = (
      <div style={ S('mt-20') } className="text-danger">All fields are required</div>
    )
    let card_area = (
      <div>
        <div style={ S('mb-20') }>
          <Card
            number={number}
            form='form'
            name={full_name}
            expiry={expiry}
            cvc={cvc}
            focused={data.focused}/>
        </div>
        <div style={ S('w-370') }>
          <form>
            <div className={`form-group${data.errors && data.errors.indexOf('number') !== -1 ? ' has-error' : ''}`}>
              <label>Card Number</label>
              <input type="text" className="form-control" name="number" onChange={ this.handleTextChange.bind(this, 'number') } value={ number }/>
            </div>
            <div className="form-group">
              <div className={`form-group${data.errors && data.errors.indexOf('first_name') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-45p pull-left mr-5p') }>
                  <label>First name</label>
                  <input type="text" className="form-control" name="first_name" onChange={ this.handleTextChange.bind(this, 'first_name') } value={ first_name }/>
                </div>
              </div>
              <div className={`form-group${data.errors && data.errors.indexOf('last_name') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-50p pull-left') }>
                  <label>Last name</label>
                  <input type="text" className="form-control" name="last_name" onChange={ this.handleTextChange.bind(this, 'last_name') } value={ last_name }/>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="form-group">
              <div className={`form-group${data.errors && data.errors.indexOf('expiry') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-50p pull-left') }>
                  <label>Expiry</label>
                  <input placeholder="DD/YY" style={ S('w-100') } maxLength="4" type="text" className="form-control" name="expiry" onChange={ this.handleTextChange.bind(this, 'expiry') } value={ expiry }/>
                </div>
              </div>
              <div className={`form-group${data.errors && data.errors.indexOf('cvc') !== -1 ? ' has-error' : ''}`}>
                <div style={ S('w-50p pull-left') }>
                  <label>CVC</label>
                  <input style={ S('w-100') } maxLength="4" type="text" className="form-control" name="cvc" onBlur={ this.flipCard.bind(this, 1) } onFocus={ this.flipCard.bind(this, 2) } onChange={ this.handleTextChange.bind(this, 'cvc') } value={ cvc }/>
                </div>
              </div>
              <div className="clearfix"></div>
              { data.errors ? error_message : ''}
            </div>
          </form>
        </div>
      </div>
    )
    if (payments && last_payment && !data.show_card_form) {
      card_area = (
        <div style={ S('pull-left m-10 w-440 br-3') }>
          <div style={ S('mb-20') }>
            <div style={ S('pull-left mr-20 font-17') }>
              Your credit and debit cards
            </div>
            <div className="clearfix"></div>
          </div>
          <div style={ S('mb-20 h-1 bg-ddd') }/>
          <div style={ S('border-1-solid-2096F3 p-15 font-14 pull-left w-100p') }>
            <div style={ S('pull-left font-14 mr-20') }>
              Ending in {last_payment.source.last4} 
            </div>
            <div style={ S('pull-left font-14 mr-20') }>
              {last_payment.source.name}
            </div>
            <div style={ S('pull-left font-14 mr-20') }>
              {last_payment.source.exp_month}/{last_payment.source.exp_year}
            </div>
            <div style={ S('pull-right font-14 pointer color-2196f3') } onClick={ this.showCardForm.bind(this) }>
              Update Card
            </div>
          </div>
        </div>
      )
    }
    return card_area
  }
  render() {
    const data = this.state.data
    let fail_message_area
    if (data.show_payment_fail) {
      fail_message_area = (
        <div style={ S('mt-10') }>
          <Alert bsStyle="danger">
            Card Edit Failed.  Please try again.
          </Alert>
        </div>
      )
    }
    let cancel_button
    if (data.payments && data.payments.length) {
      cancel_button = (
        <Button bsSize="large" bsStyle="link" onClick={ this.hideCardForm.bind(this) }>
          Cancel
        </Button>
      )
    }
    let button_area
    if (data.show_card_form) {
      button_area = (
        <div>
          <Button bsSize="large" bsStyle="primary" onClick={ this.handleEditCardClick.bind(this) } className={ data.submit_disabled || data.submitting ? 'disabled' : '' }>
            { data.submitting ? 'Submitting...' : (data.payments && data.payments.length ? 'Edit Card' : 'Add Card') }
          </Button>
          { cancel_button }
        </div>
      )
    }
    let actions_area = (
      <div>
        { button_area }
        { fail_message_area }
      </div>
    )
    if (data.show_card_updated_success) {
      actions_area = (
        <div style={ S('text-center mt-20') }>
          <div style={ S('mb-20') }>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
          </div>
          <div style={ S('font-22 mt-30n') }>
            Payment Option Edited!
          </div>
        </div>
      )
    }
    return (
      <div className="futura" style={ S('p-40') }>
        <div style={ S('w-500') }>
          <div style={ S('font-36 text-left mt-20') }>
            { data.payments && data.payments.length ? 'Update Card' : 'Add Card' }
          </div>
          { this.getCardArea() }
          { actions_area }
          <div className="clearfix"></div>
        </div>
      </div>
    )
  }
}

export default Domains


// WEBPACK FOOTER //
// ./src/components/Cards/index.js